"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toKlineTime = exports.getMaxTimeRange = exports.getTimeSpan = exports.toKlineInterval = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const isoWeek_1 = __importDefault(require("dayjs/plugin/isoWeek"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(isoWeek_1.default);
const klineIntervals = [
    {
        tv: "1S",
        rest: "1s",
        ws: "1S",
    },
    {
        tv: "1",
        rest: "1m",
        ws: "1M",
    },
    {
        tv: "3",
        rest: "3m",
        ws: "3M",
    },
    {
        tv: "5",
        rest: "5m",
        ws: "5M",
    },
    {
        tv: "15",
        rest: "15m",
        ws: "15M",
    },
    {
        tv: "30",
        rest: "30m",
        ws: "30M",
    },
    {
        tv: "60",
        rest: "1h",
        ws: "1H",
    },
    {
        tv: "120",
        rest: "2h",
        ws: "2H",
    },
    {
        tv: "240",
        rest: "4h",
        ws: "4H",
    },
    {
        tv: "360",
        rest: "6h",
        ws: "6H",
    },
    {
        tv: "480",
        rest: "8h",
        ws: "8H",
    },
    {
        tv: "720",
        rest: "12h",
        ws: "12H",
    },
    {
        tv: "1D",
        rest: "1d",
        ws: "1D",
    },
    {
        tv: "1W",
        rest: "7d",
        ws: "1W",
    },
    {
        tv: "1M",
        rest: "30d",
        ws: "1m",
    },
];
function toKlineInterval(interval, type) {
    const klineInterval = klineIntervals.find((item) => {
        return item[type] === interval;
    });
    if (klineInterval) {
        return klineInterval;
    }
    else {
        return klineIntervals[0];
    }
}
exports.toKlineInterval = toKlineInterval;
/**
 * 获取两根K线的时间间隔(毫秒)，⚠️注意：月线返回30天，与实际（自然月)）不符
 * @param interval
 */
function getTimeSpan(interval) {
    switch (interval.ws) {
        case "1S":
            return 1000;
        case "1M":
            return 60000;
        case "3M":
            return 180000;
        case "5M":
            return 300000;
        case "15M":
            return 900000;
        case "30M":
            return 1800000;
        case "1H":
            return 3600000;
        case "2H":
            return 7200000;
        case "4H":
            return 14400000;
        case "6H":
            return 21600000;
        case "8H":
            return 28800000;
        case "12H":
            return 43200000;
        case "1D":
            return 86400000;
        case "1W":
            return 604800000;
        case "1m":
            return 2592000000;
        default:
            return 60000;
    }
}
exports.getTimeSpan = getTimeSpan;
function getMaxTimeRange(interval) {
    return getTimeSpan(interval) * 2000;
}
exports.getMaxTimeRange = getMaxTimeRange;
/**
 * 将{@link timestamp}转换为K线上的时间戳
 * @param timestamp 毫秒时间戳
 * @param interval
 */
function toKlineTime(timestamp, interval) {
    if (interval.ws === "1W") {
        return (0, dayjs_1.default)(timestamp).utcOffset(0).startOf("isoWeek").valueOf();
    }
    else if (interval.ws === "1m") {
        return (0, dayjs_1.default)(timestamp).utcOffset(0).startOf("month").valueOf();
    }
    else {
        return timestamp - (timestamp % getTimeSpan(interval));
    }
}
exports.toKlineTime = toKlineTime;
